import { inject } from '@angular/core';
import { CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { AlertsService } from 'src/app/modules/shared/services/alerts.service';
import { AuthService } from '../auth/auth.service';

// EN-32926 - Mandatory alerts are shown by Summary. A page opened directly (a new tab, a pasted URL) skipped
// them, so until this tab has run the check the employee is sent to Summary first; Summary returns them to
// the requested page afterwards. Only one redirect per check, so a check that never finishes cannot trap them.
export const mandatoryAlertsGuard: CanActivateChildFn = async (_childRoute, state): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const alertService = inject(AlertsService);
  const router = inject(Router);

  if (
    state.url.startsWith('/summary') ||
    !authService.isAuthenticated() ||
    authService.isProxyToken() ||
    alertService.getHasShownMandatoryAlerts() ||
    alertService.getUrlAfterMandatoryAlerts() !== null
  ) {
    return true;
  }

  if (!authService.rightsLoaded.value) {
    try {
      await authService.getEmployeeAccessModules();
    } catch {
      return true;
    }
  }
  // EN-18175 - a terminated employee's view has no alerts (the alert APIs reject them), so there is
  // nothing to show first.
  if (!authService.employeeAccessModules.includes('Summary') || authService.isTerminatedRestricted) {
    return true;
  }

  alertService.setUrlAfterMandatoryAlerts(state.url);
  return router.createUrlTree(['/summary']);
};
